import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { KeepExploringCarousel } from "@faire/retailer-visitor-shared/components/KeepExploringCarousel";
import { CarouselContainer, Wrapper } from "@faire/retailer-visitor-shared/views/brand/logged-out/components/common";
import React from "react";
export var CategoriesCarousel = function(_param) {
    var ref = _param.ref, props = _object_without_properties(_param, [
        "ref"
    ]);
    return /*#__PURE__*/ _jsx(Wrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsx(CarouselContainer, {
            children: /*#__PURE__*/ _jsx(KeepExploringCarousel, {
                dataTestId: "logged-out-brand-keep-exploring",
                clickTrackPath: "logged-out-brand/categories-carousel",
                highlightCategoryPath: props.topCategoryPath
            })
        })
    });
};
